import { render } from "./Main_Box.vue?vue&type=template&id=0f400476&scoped=true"
import script from "./Main_Box.vue?vue&type=script&lang=js"
export * from "./Main_Box.vue?vue&type=script&lang=js"

import "./Main_Box.vue?vue&type=style&index=0&id=0f400476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f400476"]])

export default __exports__